import { useTranslation } from 'react-i18next'
import React from 'react'

import { useStepsState } from '@btime/react-contexts'
import IconButton from '../actions/IconButton'
import { COLORS } from '@btime/constants'
import { useChecklistFormActions } from '../../modules/checklists/edit/_form/ChecklistFormHandler'
import { useSessionPermission } from '@btime/react-session'

const UndoButton = ({ color }) => {
  const { t } = useTranslation('components')
  const { isLast } = useStepsState()
  const { handleUndo, canUndo } = useChecklistFormActions()
  const shouldShowUndoOption = useSessionPermission('showUndoOption')

  const commonSubmitProps = { color: color || COLORS.purple }

  return (
    <>
      {isLast && canUndo && shouldShowUndoOption && (
        <IconButton
          label={t('undo')}
          iconLeft="BsArrowCounterclockwise"
          onClick={handleUndo}
          {...commonSubmitProps}
          transparent
        />
      )}
    </>
  )
}

export default UndoButton
